import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { api } from '../lib/api';
import { Button } from './ui/Button';
import { LABEL_TERRITOIRE_USER } from '../lib/format';

export function Header(): JSX.Element {
  const user = useAuthStore((s) => s.user);
  const clear = useAuthStore((s) => s.clear);
  const navigate = useNavigate();

  const handleLogout = async (): Promise<void> => {
    try {
      await api.auth.logout();
    } catch (err) {
      console.error('Logout error:', err);
    }
    clear();
    navigate('/login');
  };

  return (
    <header className="h-14 border-b border-slate-800 bg-slate-950 flex items-center justify-between px-6 shrink-0">
      <div />
      <div className="flex items-center gap-4">
        {user !== null && (
          <div className="text-right">
            <div className="text-sm text-slate-200 leading-tight">{user.nom_complet}</div>
            <div className="text-[10px] text-slate-500 leading-tight">
              {LABEL_TERRITOIRE_USER[user.territoire] ?? user.territoire}
            </div>
          </div>
        )}
        <Button variant="ghost" size="sm" onClick={(): void => void handleLogout()}>
          Se déconnecter
        </Button>
      </div>
    </header>
  );
}
